var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehiclesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "jxc68p1g5a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.537255 0 0 0 0 0.545098 0 0 0 0 0.552941 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#jxc68p1g5a)",
    transform: "translate(-311 -415) translate(30 168)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M15.429 14.093V7.1c0-2.312-2.131-2.817-4.907-2.892l.62-1.25h2.654V1.713H5.633v1.243H9.51l-.62 1.26C6.335 4.29 4 4.805 4 7.1v6.993c0 1.202.971 2.204 2.114 2.461l-1.298 1.317v.415h1.82l1.633-1.657h3.078l1.633 1.657h1.632v-.415l-1.224-1.242h-.066c1.38 0 2.107-1.136 2.107-2.536zm-5.715 1.293c-.677 0-1.224-.555-1.224-1.243 0-.688.547-1.243 1.224-1.243.678 0 1.225.555 1.225 1.243 0 .688-.547 1.243-1.225 1.243zm4.082-3.729H5.633V7.514h8.163v4.143z",
    transform: "translate(281 247)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehiclesIcon);
export default __webpack_public_path__ + "static/media/vehicles-icon.34b9d1a62e0c52feeb0873b793508531.svg";
export { ForwardRef as ReactComponent };